import Adds from 'modules/Adds';
import Header from 'modules/header/wholesaler/main';

import React from 'react';
import {useLocation} from 'react-router';

const AddsContainer = () => {
  const {state} = useLocation();

  return (
    <div className="w-full h-full">
      <Header title={state.title} />
      <Adds app="market" />
    </div>
  );
};

export default AddsContainer;
